<template>
  <router-view />
</template>

<script>
export default {
  name: 'RentalCompaniesIndex'
}
</script>
